import { List, ListItem, ListItemText, Typography } from "@material-ui/core";
import React from "react";
import { addContactV2Style } from "./AddContactV2Style";
import { CONTACT_TYPE } from "./AddContactV3";

const AddContactSidebar = ({
  contactType,
  selectedSection,
  setSelectedSection,
  personalInfoRef,
  relatedContactsRef,
  businessInfoRef,
  primaryContactRef,
  additionalInfoRef,
}) => {
  const classes = addContactV2Style();
  return (
    <div className={classes.sidebarWrapper}>
      {contactType === CONTACT_TYPE.PERSONAL ? (
        <List
          className={classes.sidebarList}
          component="div"
          aria-label="main mailbox folders"
          dense
          style={{paddingLeft: '12px'}}
        >
          <ListItem
            button
            className={classes.sideBarButton}
            selected={selectedSection === "Personal Info"}
            onClick={() => {
              if (personalInfoRef.current) {
                personalInfoRef.current.scrollIntoView({
                  behavior: "smooth",
                });
                setSelectedSection("Personal Info");
              }
            }}
          >
            <ListItemText>
              <Typography
                color={"text.primary"}
                variant="body2"
                fontWeight={600}
              >
                Personal Info
              </Typography>
            </ListItemText>
          </ListItem>
          <ListItem
            button
            className={classes.sideBarButton}
            selected={selectedSection === "Related Contacts"}
            onClick={() => {
              if (relatedContactsRef.current) {
                relatedContactsRef.current.scrollIntoView({
                  behavior: "smooth",
                });
                setSelectedSection("Related Contacts");
              }
            }}
          >
            <ListItemText>
              <Typography
                color={"text.primary"}
                variant="body2"
                fontWeight={600}
              >
                Related Contacts
              </Typography>
            </ListItemText>
          </ListItem>
          <ListItem
            button
            className={classes.sideBarButton}
            selected={selectedSection === "Additional Info"}
            onClick={() => {
              if (additionalInfoRef.current) {
                additionalInfoRef.current.scrollIntoView({
                  behavior: "smooth",
                });
                setSelectedSection("Additional Info");
              }
            }}
          >
            <ListItemText>
              <Typography
                color={"text.primary"}
                variant="body2"
                fontWeight={600}
              >
                Additional Info
              </Typography>
            </ListItemText>
          </ListItem>
        </List>
      ) : (
        <List
          className={classes.sidebarList}
          component="div"
          aria-label="main mailbox folders"
          dense
          style={{paddingLeft: '12px'}}
        >
          <ListItem
            button
            className={classes.sideBarButton}
            selected={selectedSection === "Business Info"}
            onClick={() => {
              if (businessInfoRef.current) {
                businessInfoRef.current.scrollIntoView({
                  behavior: "smooth",
                });
                setSelectedSection("Business Info");
              }
            }}
          >
            <ListItemText>
              <Typography
                color={"text.primary"}
                variant="body2"
                fontWeight={600}
              >
                Business Info
              </Typography>
            </ListItemText>
          </ListItem>
          <ListItem
            button
            className={classes.sideBarButton}
            selected={selectedSection === "Primary Contact"}
            onClick={() => {
              if (primaryContactRef.current) {
                primaryContactRef.current.scrollIntoView({
                  behavior: "smooth",
                });
                setSelectedSection("Primary Contact");
              }
            }}
          >
            <ListItemText>
              <Typography
                color={"text.primary"}
                variant="body2"
                fontWeight={600}
              >
                Primary Contact
              </Typography>
            </ListItemText>
          </ListItem>
          <ListItem
            button
            className={classes.sideBarButton}
            selected={selectedSection === "Additional Info"}
            onClick={() => {
              if (additionalInfoRef.current) {
                additionalInfoRef.current.scrollIntoView({
                  behavior: "smooth",
                });
                setSelectedSection("Additional Info");
              }
            }}
          >
            <ListItemText>
              <Typography
                color={"text.primary"}
                variant="body2"
                fontWeight={600}
              >
                Additional Info
              </Typography>
            </ListItemText>
          </ListItem>
        </List>
      )}
    </div>
  );
};

export default AddContactSidebar;
